import { Box } from "@mui/material";
type FieldIconContainerPropsType = {
  imgSrc: string,
  imgStyle: object,
  containerStyle?: object
}
const FieldIconContainer = ({ imgSrc, imgStyle, containerStyle }: FieldIconContainerPropsType) => {
  return (
    <Box mr={1} width={20} display="flex" alignItems="center" sx={containerStyle}>
      <img src={imgSrc} style={imgStyle} />
    </Box>
  )
}
export default FieldIconContainer;
